import React from "react";
import ClinicalReportSection from "./ClinicalReportSection";
import { dischargeSummaryConfig } from "./abhaClinicalConfigs";

const DischargeSummarySection = ({ patientId, patientData }) => (
  <ClinicalReportSection
    patientId={patientId}
    patientData={patientData}
    config={dischargeSummaryConfig}
  />
);

export default DischargeSummarySection;
